export const TABLE_UPDATE = "GASTROHUBLOCATION_GROUPS/TABLE_UPDATE";
export const FETCH_SUCCESS = "GASTROHUBLOCATION_GROUPS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "GASTROHUBLOCATION_GROUPS/DESTROY_FAILED",
    DESTROY_REQUEST: "GASTROHUBLOCATION_GROUPS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "GASTROHUBLOCATION_GROUPS/DESTROY_SUCCESS",

    FETCH_FAILED: "GASTROHUBLOCATION_GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "GASTROHUBLOCATION_GROUPS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "GASTROHUBLOCATION_GROUPS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "GASTROHUBLOCATION_GROUPS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "GASTROHUBLOCATION_GROUPS/FETCH_ALL_SUCCESS",

    GET_FAILED: "GASTROHUBLOCATION_GROUPS/GET_FAILED",
    GET_REQUEST: "GASTROHUBLOCATION_GROUPS/GET_REQUEST",
    GET_SUCCESS: "GASTROHUBLOCATION_GROUPS/GET_SUCCESS",

    PATCH_FAILED: "GASTROHUBLOCATION_GROUPS/PATCH_FAILED",
    PATCH_REQUEST: "GASTROHUBLOCATION_GROUPS/PATCH_REQUEST",
    PATCH_SUCCESS: "GASTROHUBLOCATION_GROUPS/PATCH_SUCCESS",

    STORE_FAILED: "GASTROHUBLOCATION_GROUPS/STORE_FAILED",
    STORE_REQUEST: "GASTROHUBLOCATION_GROUPS/STORE_REQUEST",
    STORE_SUCCESS: "GASTROHUBLOCATION_GROUPS/STORE_SUCCESS",

    UPDATE_FAILED: "GASTROHUBLOCATION_GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "GASTROHUBLOCATION_GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "GASTROHUBLOCATION_GROUPS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
